import { render, staticRenderFns } from "./DeliveryBlockSlaughterHouse.vue?vue&type=template&id=4c855293&"
import script from "./DeliveryBlockSlaughterHouse.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockSlaughterHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports